<template>
    <teleport to="body">
        <jet-dialog-modal id="addShipmentItemToReturnCartModal" maxwidth="xl">
            <template #title>{{ (isWarranty ? 'Warranty ' : 'Return ') + shipmentItem?.product?.sku }}</template>
            <template #content>
                <div v-if="shipmentItem">
                    <div class="border-bottom">
                        <div class="p-3">
                            <p v-if="!isWarranty" class="text-secondary font-italic">
                                Returns must be like new condition and in orignal packaging
                            </p>
                            <div class="row pl-3 pr-3">
                                <div class="mr-3 " v-if="shipmentItem.product.thumb_url">
                                    <img :src="shipmentItem.product.thumb_url" alt="Product Image"
                                        style="max-width: 80px; max-height: 80px;" />
                                </div>
                                <div class="col">
                                    <div class="mb-0"><span class="font-weight-bold">{{ shipmentItem.product.sku
                                    }}</span>
                                    </div>
                                    <div class="text-secondary">{{ shipmentItem.product.name }}</div>
                                    <div v-if="!isWarranty">
                                        <span>Price: {{ formatDollars(shipmentItem.order_item.cost_item) }}</span>
                                        <span v-if="shipmentItem.restocking_fee_per_item > 0" class="text-danger ml-2">
                                            Restocking Fee {{ formatDollars(shipmentItem.restocking_fee_per_item) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="isWarranty && shipmentItem.product?.warranty?.warranty_link"
                                class="mt-2 text-center">
                                <strong>
                                    <a :href="shipmentItem.product.warranty.warranty_link" target="_blank">
                                        Warranty Information
                                    </a>
                                </strong>
                            </div>
                        </div>
                    </div>
                    <div class="p-3">
                        <div v-if="isWarranty && shipmentItem.product.product_set_parts.length" class="mb-3">
                            <div class="font-weight-bold">Please Select the Defective Parts</div>
                            <div v-for="part in shipmentItem.product.product_set_parts" class="mt-2 pb-2 border-bottom"
                                :key="shipmentItem.product.product_set_parts.product_id">
                                <div>
                                    <Checkbox v-model="formReturn.selectedPartIds" :inputId="part.product_id"
                                        :value="part.product_id" class="mb-1" />
                                    <label :for="part.product_id" class="mb-0">
                                        <span class="ml-2">{{ part.product.sku }}</span>
                                        <span class="text-secondary"> - {{ part.product.name }}</span>
                                    </label>
                                </div>
                                <div v-if="part.quantity > 1 && formReturn.selectedPartIds.includes(part.product_id)"
                                    class="pl-4 pt-2">
                                    <InputNumber :id="`return_qty${part.product_id}`"
                                        v-model="formReturn.selectedPartsQuantities[part.product_id]" inputId="integeronly"
                                        :min="1" :max="part.quantity" showButtons buttonLayout="horizontal" :step="1"
                                        decrementButtonClass="btn-danger" inputClass="quantityInput" style="height: 35px;">
                                        <template #incrementbuttonicon>
                                            <span class="pi pi-plus"></span>
                                        </template>
                                        <template #decrementbuttonicon>
                                            <span class="pi pi-minus"></span>
                                        </template>
                                    </InputNumber>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <label for="return_qty" class="font-weight-bold">Number Returning</label>
                            <div class="row m-0">
                                <div>
                                    <InputNumber id="return_qty" v-model="formReturn.quantity_returning"
                                        inputId="integeronly" :min="1" :max="shipmentItem.returnable_quantity" showButtons
                                        buttonLayout="horizontal" :step="1" decrementButtonClass="btn-danger"
                                        :disabled="singleWarrantyRequired" inputClass="quantityInput" style="height: 35px;">
                                        <template #incrementbuttonicon>
                                            <span class="pi pi-plus"></span>
                                        </template>
                                        <template #decrementbuttonicon>
                                            <span class="pi pi-minus"></span>
                                        </template>
                                    </InputNumber>
                                </div>
                                <div class="pt-2">
                                    <span v-if="singleWarrantyRequired" class="ml-3">
                                        Warranty information required for each item
                                    </span>
                                    <span v-else class="ml-3">{{ shipmentItem.returnable_quantity }} Eligible for {{
                                        isWarranty ? 'Warranty' : 'Return' }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="mb-1">
                            <div class="mt-3" v-if="isWarranty && shipmentItem.product?.warranty?.picture_required">
                                <label for="warranty_image" class="font-weight-bold">Image of defective item
                                    required</label>
                                <FileUpload ref="warrantyImageFileUpload" id="warranty_image" mode="basic" accept="image/*"
                                    chooseLabel="Select Image" @select="(event) => selectFile(event)" customUpload>
                                    <template #chooseicon>
                                        <i class="fa fa-times-circle mr-2"></i>
                                    </template>
                                </FileUpload>
                            </div>
                            <div class="mt-3" v-if="isWarranty && shipmentItem.product?.warranty?.serial_number_required">
                                <label for="serial_number" class="font-weight-bold">Serial Number</label>
                                <input id="serial_number" placeholder="Serial Number" v-model="formReturn.serial_number"
                                    class="form-control" />
                            </div>
                        </div>
                        <div class="mt-3">
                            <label for="return_comments" class="font-weight-bold">Reason for {{
                                isWarranty ? 'Warranty' : 'Return' }}</label>
                            <textarea id="return_comments" v-model="formReturn.comments" class="form-control"></textarea>
                        </div>
                    </div>
                </div>
                <div v-else class="p-3">
                    <h4>No Product Selected</h4>
                </div>
            </template>
            <template #footer>
                <jet-button v-if="shipmentItem" class="ml-2" @click="submit()" :disable="working">Add</jet-button>
                <jet-button class="ml-2" btn-style="danger" data-dismiss="modal">Cancel</jet-button>
            </template>
        </jet-dialog-modal>
    </teleport>
</template>

<script>
import JetDialogModal from '@/Jetstream/DialogModal'
import InputNumber from 'primevue/inputnumber';
import FileUpload from 'primevue/fileupload'
import toastr from 'toastr'
import Multiselect from '@vueform/multiselect'
import Checkbox from 'primevue/checkbox';

export default {
    emits: ['itemAddedToReturnCart'],
    components: {
        JetDialogModal,
        FileUpload,
        InputNumber,
        Multiselect,
        Checkbox,
    },
    props: {
        shipmentItem: Object,
        isWarranty: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            working: false,
            formReturn: this.$inertia.form({
                shipmentItemId: null,
                isWarranty: this.isWarranty,
                selectedPartIds: [],
                selectedPartsQuantities: [],
                quantity_returning: 1,
                warranty_image: null,
                serial_number: '',
                comments: '',
            }),
        }
    },
    created() {
        this.moment = moment;
    },
    mounted() {
        this.$emit("show", {
            show: () => {
                $('#addShipmentItemToReturnCartModal').modal('show');
                if (this.$refs.warrantyImageFileUpload) {
                    this.$refs.warrantyImageFileUpload.clear();
                    this.$refs.warrantyImageFileUpload.uploadedFileCount = 0;
                }
            }
        });
    },
    computed: {
        singleWarrantyRequired() {
            return this.isWarranty &&
                (this.shipmentItem.product?.warranty?.picture_required ||
                    this.shipmentItem.product?.warranty?.serial_number_required);
        }
    },
    watch: {
        shipmentItem() {
            this.resetReturnForm()
        },
        isWarranty() {
            this.resetReturnForm()
        },
    },
    methods: {
        resetReturnForm() {
            this.formReturn.shipmentItemId = this.shipmentItem?.id
            this.formReturn.isWarranty = this.isWarranty
            this.formReturn.selectedPartIds = []
            this.formReturn.selectedPartsQuantities = []
            this.formReturn.quantity_returning = 1
            this.formReturn.warranty_image = null
            this.formReturn.serial_number = ''
            this.formReturn.comments = ''
            if (this.shipmentItem?.product?.product_set_parts.length) {
                for (const part of this.shipmentItem.product.product_set_parts) {
                    this.formReturn.selectedPartsQuantities[part.product_id] = 1
                }
            }
        },
        selectFile(event) {
            this.resizeImage(event.files[0])
        },
        submit() {
            if (this.validate()) {
                this.working = true;
                this.formReturn.post(this.route('mtd.return.addReturnItem'), {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$emit('itemAddedToReturnCart');
                        $('#addShipmentItemToReturnCartModal').modal('hide');
                        toastr.success('Added to your Return Cart.');
                    },
                    onFinish: () => this.working = false,
                });
            }
        },
        validate() {
            let valid = true;
            if (this.isInputEmpty(this.formReturn.comments)) {
                toastr.error("Reason is required");
                valid = false;
            }

            if (this.isWarranty) {
                if (this.shipmentItem.product?.warranty?.picture_required &&
                    !this.formReturn.warranty_image) {
                    toastr.error("Picture of defective item(s) is required")
                    valid = false;
                }
                if (this.shipmentItem.product?.warranty?.serial_number_required &&
                    this.isInputEmpty(this.formReturn.serial_number)) {
                    toastr.error("Serial Number is required")
                    valid = false;
                }

                if (this.shipmentItem.product.product_set_parts.length &&
                    (!this.formReturn.selectedPartsQuantities.length || this.formReturn.selectedPartsQuantities.length < 1)) {
                    toastr.error("Please select which parts in the set are deffective")
                    valid = false;
                }
            }
            return valid
        },
        isInputEmpty(inputValue) {
            return !inputValue || inputValue.replace(/\s/gi, '').length == 0
        },
        resizeImage(file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                const img = new Image();
                img.src = e.target.result;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    // Set the canvas size to the desired dimensions
                    const maxWidth = 1500;
                    const maxHeight = 1500;
                    let width = img.width;
                    let height = img.height;

                    if (width > height) {
                        if (width > maxWidth) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        }
                    } else if(height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }


                    canvas.width = width;
                    canvas.height = height;

                    // Draw the image on the canvas
                    ctx.drawImage(img, 0, 0, width, height);

                    // Convert the canvas content to base64 data URL
                    const resizedDataUrl = canvas.toDataURL('image/jpeg');

                    this.formReturn.warranty_image = resizedDataUrl;
                };
            };

            reader.readAsDataURL(file);
        },
    },
}
</script>

<style>
.quantityInput {
    width: 50px !important;
    text-align: center;
}
</style>
